<template>
    <v-container>
        <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
        <v-row class="mt-10">
            <v-col>
                <span class="header bold text-tcdc-green text-uppercase">{{$t('serviceArea.visitServiceArea')}}</span>
                <VisitLayout />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ServiceExpandable from "../../components/expandables/ServiceExpandable";
    import { mapState } from 'vuex';
    import VisitLayout from "../../components/visit_service_area/Visit";
    export default {
        created() {
            this.items[0].text = this.branchName;
        },
        computed: {
            ...mapState({
                branchName: state => state.Branch.branch_name,
                service_area: state => {
                    return state.ServiceMenu.service_area
                }
            }),
            branchChanged: function () {
                return this.branchName;
            }
        },
        watch: {
            branchChanged: function() {
                this.items[0].text = this.branchChanged;
            }
        },
        data: () => ({
            items: [
                {
                    text: 'TCDC BANGKOK',
                    to: "/home"
                },
                {
                    text: "SERVICE",
                    href: "/service",
                },
                {
                    text: "VISIT & SERVICE AREA",
                    disabled: true,
                }
            ]
        }),
        components: {
            VisitLayout,
        }
    };
</script>

<style></style>
